import { getValue, setValue } from "@utils/lodash";
const onPrem = getValue(localStorage, `op`, "") === "false";

export const allNavigationMenu = [
  {
    title: "DashBoard",
    icon: "/images/navigation-icons/dashboard.svg",
    // link: "dashboard",
    parentLink: "/dashboard",
    name: "dashboard",
    menu: [
      {
        title: "Vendor Compliance",
        link: "/dashboard/vendor-compliance",
        name: "dashboard_vendor_audit",
      },
      // {
      //   title: "Vendor Audits",
      //   link: "/dashboard/vendor-audits",
      //   name: "dashboard_vendor_audit",
      // },
      {
        title: "Compliance",
        link: "/dashboard/compliance",
        name: "dashboard_compliance",
      },
      {
        title: "License",
        link: "/dashboard/license",
        name: "dashboard_license",
      },

      // {
      //   title: "Self Activity",
      //   link: "/dashboard/self-compliance/my-activity",
      //   name: "dashboard_self_activity",
      // },
      // {
      //   title: "Self Compliance",
      //   link: "/dashboard/self-compliance/compliance",
      //   name: "dashboard_self_compliance",
      // },
      {
        title: "Self Compliance",
        // link: "/dashboard/self-compliance/compliance",
        name: "dashboard_self_compliance_my_activity",
        parent: "dashboard",
        childrens: [
          {
            title: "My Activity",
            // link: "/dashboard/self-compliance/my-activity",
            link: "/dashboard/self-compliance/my-activity-v2",
            name: "dashboard_self_compliance_my_activity",
          },
          {
            title: "Compliance",
            link: "/dashboard/self-compliance/compliance",
            name: "dashboard_self_compliance_compliance",
          },
        ],
      },
      {
        title: "Internal Compliance",
        // link: "/dashboard/self-compliance/compliance",
        name: "dashboard_internal_compliance_my_activity",
        parent: "dashboard",
        childrens: [
          {
            title: "My Activity",
            link: "/dashboard/internal-compliance/my-activity",
            name: "dashboard_internal_compliance_my_activity",
          },
          {
            title: "Compliance",
            link: "/dashboard/internal-compliance/compliance",
            name: "dashboard_internal_compliance_compliance",
          },
        ],
      },
    ],
  },
  {
    title: "Audit",
    icon: "/images/navigation-icons/audit.svg",
    parentLink: "/audit",
    name: "audit",
    menu: [
      {
        title: "Audit Status",
        icon: "/images/leftnav/manage_audit.svg",
        parentLink: "/audit/audit-status",
        link: "/audit/audit-status",
        name: "audit_audit_status",
      },
      {
        title: "MIS & Reports",
        icon: "/images/leftnav/manage_audit.svg",
        parentLink: "/audit/mis-reports",
        link: "/audit/mis-reports",
        name: "audit_mis_report",
      },
      {
        title: "Manage Audit",
        icon: "/images/leftnav/manage_audit.svg",
        parentLink: "/audit/manage-audit",
        link: "/audit/manage-audit",
        name: "audit_manage_audit",
      },
      {
        title: "Vendor Audit",
        icon: "/images/leftnav/manage_audit.svg",
        parentLink: "/audit/vendor-audit",
        link: "/audit/vendor-audit",
        name: "audit_vendor_audit",
      },

      {
        title: "Vendor Audit",
        icon: "/images/leftnav/manage_audit.svg",
        parentLink: "/audit/vendor",
        // link: "/audit/vendor",
        name: "audit_vendor_audit_uploaded",
        parent: "audit",
        childrens: [
          {
            title: "Submitted",
            link: "/audit/vendor/uploaded",
            name: "audit_vendor_audit_uploaded",
            parent: "audit",
          },
          {
            title: "Completed",
            link: "/audit/vendor/completed",
            name: "audit_vendor_audit_completed",
            parent: "audit",
          },
          {
            title: "Not Submitted",
            link: "/audit/vendor/not-uploaded",
            name: "audit_vendor_audit_not_completed",
            parent: "audit",
          },
        ],
      },
      {
        title: "Compliance Audit",
        icon: "/images/leftnav/compliance-audit.svg",
        // link: "/audit/compliance-audit/pending-audit",
        parentLink: "/audit/compliance-audit/pending-audit",
        name: "audit_compliance_audit_pending",
        parent: "compliance_audit",
        childrens: [
          {
            title: "Pending Audit",
            link: "/audit/compliance-audit/pending-audit",
            name: "audit_compliance_audit_pending",
            parent: "audit",
          },
          {
            title: "Completed Audit",
            link: "/audit/compliance-audit/completed-audit",
            name: "audit_compliance_audit_completed",
            parent: "audit",
          },
        ],
      },
    ],
  },
  {
    title: "Activities",
    icon: "/images/leftnav/activities.svg",
    // link: "activities",
    parentLink: "/activities",
    name: "activities",
    menu: [
      // {
      // 	title: 'My Task',
      // 	link: '/task/my-task',
      // 	name: 'task_my-task',
      // },
      {
        title: "Self Compliance",
        icon: "/images/leftnav/tasks.svg",
        // link: "/activities/self-compliance/my-task",
        parentLink: "/activities/self-compliance/my-task",
        name: "activities_self_compliance_executor_task",
        parent: "activities",
        childrens: [
          {
            // title: "My Task",
            title: "Executor Task",
            link: "/activities/self-compliance/my-task",
            name: "activities_self_compliance_executor_task",
            parent: "activities",
          },
          {
            title: "Evaluator Approval",
            link: "/activities/self-compliance/pending-approval",
            name: "activities_self_compliance_evaluator_approval",
            parent: "activities",
          },
          {
            title: "Completed Tasks",
            link: "/activities/self-compliance/approved-task",
            name: "activities_self_compliance_completed_task",
            parent: "activities",
          },
        ],
      },
      {
        title: "Internal Compliance",
        icon: "/images/leftnav/tasks.svg",
        parentLink: "/activities/internal-compliance/my-task",
        name: "activities_internal_compliance_executor_task",
        parent: "activities",
        childrens: [
          {
            title: "Executor Task",
            link: "/activities/internal-compliance/my-task",
            name: "activities_internal_compliance_executor_task",
            parent: "activities",
          },
          {
            title: "Evaluator Approval",
            link: "/activities/internal-compliance/pending-approval",
            name: "activities_internal_compliance_evaluator_approval",
            parent: "activities",
          },
          {
            title: "Completed Tasks",
            link: "/activities/internal-compliance/approved-task",
            name: "activities_internal_compliance_completed_task",
            parent: "activities",
          },
        ],
      },
      {
        title: "PE Compliance",
        link: "/activities/task/compliance",
        name: "activities_pe_compliance",
        parent: "activities",
      },
      {
        title: "License",
        // link: "/activities/task/license",
        link: "/activities/task/license/group",
        name: "activities_licenses",
        parent: "activities",
      },
    ],
  },
  {
    title: "Repository",
    icon: "/images/leftnav/repository.svg",
    // link: "repository",
    parentLink: "/repository",
    name: "repository",
    menu: [
      {
        title: "Mapped Checkpoint",
        icon: "/images/leftnav/repository.svg",
        // link: "/repository/mapped-checkpoint/master",
        parentLink: "/repository",
        name: "repository_mapped_checkpoint_master",

        childrens: [
          {
            title: "Master",
            link: "/repository/mapped-checkpoint/master",
            name: "repository_mapped_checkpoint_master",
            parent: "repository",
          },
          {
            title: "Function Head",
            link: "/repository/mapped-checkpoint/function-head",
            name: "repository_mapped_checkpoint_function_head",
            parent: "repository",
          },
          {
            title: "Evaluator",
            link: "/repository/mapped-checkpoint/evaluator",
            name: "repository_mapped_checkpoint_evaluator",
            parent: "repository",
          },
        ],
      },
      {
        title: "Internal Mapping",
        icon: "/images/leftnav/repository.svg",
        // link: "/repository/mapped-checkpoint/master",
        parentLink: "/repository",
        name: "repository_internal_mapping_master",

        childrens: [
          {
            title: "Master",
            link: "/repository/internal-mapping/master",
            name: "repository_internal_mapping_master",
            parent: "repository",
          },
          {
            title: "Function Head",
            link: "/repository/internal-mapping/function-head",
            name: "repository_internal_mapping_function_head",
            parent: "repository",
          },
          {
            title: "Evaluator",
            link: "/repository/internal-mapping/evaluator",
            name: "repository_internal_mapping_evaluator",
            parent: "repository",
          },
        ],
      },
      {
        title: "Checkpoint",
        icon: "/images/leftnav/checkpoint.svg",
        parentLink: "/checkpoint",
        // link: "/repository/checkpoint/master",
        name: "repository_checkpoint_company_master",
        childrens: [
          {
            title: "Master",
            link: "/repository/checkpoint/master",
            name: "repository_checkpoint_company_master",
            parent: "repository",
          },
          {
            title: "Vendor Checkpoints",
            link: "/repository/checkpoint/vendor-checkpoints",
            name: "repository_checkpoint_vendor_checkpoints",
            parent: "repository",
          },
          {
            title: "Release Dates",
            link: "/repository/checkpoint/release-dates-new",
            name: "repository_checkpoint_release_date",
            parent: "repository",
          },
          {
            title: "PE Compliance",
            link: "/repository/checkpoint/PE-compliance",
            name: "repository_checkpoint_pe_compliance",
            parent: "repository",
          },
          {
            title: "License",
            link: "/repository/checkpoint/license",
            name: "repository_checkpoint_license",
            parent: "repository",
          },
          {
            title: "Assigned Tasks",
            link: "/repository/checkpoint/assigned-tasks",
            name: "repository_checkpoint_assigned_tasks",
            parent: "repository",
          },
        ],
      },

      {
        title: "Internal Compliance",
        icon: "/images/leftnav/repository.svg",
        // link: "/repository/mapped-checkpoint/master",
        parentLink: "/repository",
        name: "repository_internal_compliance_company_master",

        childrens: [
          {
            title: "Master",
            link: "/repository/internal-compliance/master",
            name: "repository_internal_compliance_company_master",
            parent: "repository",
          },
          {
            title: "Assigned Tasks",
            link: "/repository/internal-compliance/assigned-tasks",
            name: "repository_internal_compliance_assigned_tasks",
            parent: "repository",
          },
        ],
      },

      {
        title: "Vendor Compliance",
        icon: "/images/leftnav/repository.svg",
        // link: "/repository/mapped-checkpoint/master",
        parentLink: "/repository",
        name: "repository_vendor_compliance_master",

        childrens: [
          {
            title: "Master",
            link: "/repository/vendor-compliance/master",
            name: "repository_vendor_compliance_master",
            parent: "repository",
          },
        ],
      },

      {
        title: "Legacy Tasks",
        icon: "/images/leftnav/repository.svg",
        // link: "/repository/mapped-checkpoint/master",
        parentLink: "/repository",
        name: "repository_legacy_task_master",

        childrens: [
          {
            title: "Master",
            link: "/repository/legacy-task/master",
            name: "repository_legacy_task_master",
            parent: "repository",
          },
          {
            title: "Executor",
            link: "/repository/legacy-task/executor",
            name: "repository_legacy_task_executor",
            parent: "repository",
          },

          {
            title: "Evaluator",
            link: "/repository/legacy-task/evaluator",
            name: "repository_legacy_task_evaluator",
            parent: "repository",
          },

          {
            title: "Function Head",
            link: "/repository/legacy-task/function-head",
            name: "repository_legacy_task_function_head",
            parent: "repository",
          },
        ],
      },

      onPrem
        ? {
            title: "Legal Update",
            icon: "/images/leftnav/repository.svg",
            parentLink: "/repository",
            link: "/repository/legal-update",
            name: "repository_legal_update",
            parent: "repository",
          }
        : "",
      onPrem
        ? {
            title: "Document Library",
            icon: "/images/leftnav/repository.svg",
            parentLink: "/repository",
            link: "/repository/document-library",
            name: "repository_document_library",
            parent: "repository",
          }
        : "",
      {
        title: "Task Document",
        icon: "/images/leftnav/repository.svg",
        parentLink: "/repository",
        link: "/repository/task-document",
        name: "repository_task_library",
        parent: "repository",
      },
    ],
  },
  {
    title: "Configuration",
    icon: "/images/leftnav/repository.svg",
    link: "/configuration/vendors",
    parentLink: "/configuration/vendors",
    name: "configuration",
    parent: "configuration",
    menu: [
      {
        title: "Mapping",
        icon: "/images/leftnav/entity-mapping.svg",
        parentLink: "/configuration/entity-mapping",
        // link: "/configuration/entity-mapping",
        name: "configuration_mapping_entity_mapping",
        parent: "configuration",
        childrens: [
          {
            title: "Entity Mapping",
            icon: "/images/leftnav/entity-mapping.svg",
            parentLink: "/configuration/entity-mapping",
            link: "/configuration/entity-mapping",
            name: "configuration_mapping_entity_mapping",
          },
          {
            title: "Internal Mapping",
            icon: "/images/leftnav/entity-mapping.svg",
            parentLink: "/configuration/internal-mapping",
            link: "/configuration/internal-mapping",
            name: "configuration_mapping_internal_mapping",
          },
        ],
      },
      {
        title: "Vendors",
        icon: "/images/leftnav/vendors.svg",
        parentLink: "/configuration/vendors",
        link: "/configuration/vendors",
        name: "configuration_vendor",
        parent: "configuration",
      },

      {
        title: "Location",
        icon: "/images/leftnav/location_icon.svg",
        parentLink: "/configuration/locations",
        link: "/configuration/locations",
        name: "configuration_location",
        parent: "configuration",
      },
      {
        title: "List Management",
        icon: "/images/leftnav/list-management.svg",
        parentLink: "/list-management",
        // link: "//configuration/list-management/choice-list",
        name: "configuration_list_management_choice_list",
        parent: "configuration",
        childrens: [
          {
            title: "Choice List",
            link: "/configuration/list-management/choice-list",
            name: "configuration_list_management_choice_list",
          },
          {
            title: "Checkpoint",
            link: "/configuration/list-management/checkPoint",
            name: "configuration_list_management_checkpoint",
          },
        ],
      },
      {
        title: "Internal Compliance",
        icon: "/images/leftnav/list-management.svg",
        parentLink: "/internal-compliance",
        name: "configuration_internal_compliance_fields",
        parent: "configuration",
        childrens: [
          {
            title: "Fields",
            link: "/configuration/internal-compliance/fields",
            name: "configuration_internal_compliance_fields",
          },
          {
            title: "Field List",
            link: "/configuration/internal-compliance/field-list",
            name: "configuration_internal_compliance_field_list",
          },
        ],
      },
    ],
  },
  {
    title: "Reports",
    icon: "/images/leftnav/reports.svg",
    parentLink: "/reports",
    name: "report",
    parent: "report",
    menu: [
      {
        title: "Reports",
        icon: "/images/leftnav/reports.svg",
        parentLink: "/reports",
        name: "report_analytics_vendor_audit",
        parent: "report",
        childrens: [
          // {
          //   title: "Vendor Audit",
          //   link: "/report/vendor-audit",
          //   name: "report_analytics_vendor_audit",
          //   parent: "report",
          // },
          // {
          //   title: "PE Compliance",
          //   link: "/report/pe-compliance",
          //   name: "report_analytics_pe_compliance",
          //   parent: "report",
          // },
          // {
          //   title: "License",
          //   link: "/report/license",
          //   name: "report_analytics_license",
          //   parent: "report",
          // },
          {
            title: "Fixed Reports",
            link: "/report/fixed-reports",
            name: "report_analytics_fixed_report",
            parent: "report",
          },
          {
            title: "Self Compliance",
            link: "/report/self-compliance-reports",
            name: "report_analytics_self_compliance",
            parent: "report",
          },
          {
            title: "Internal Compliance",
            link: "/report/internal-compliance-reports",
            name: "report_analytics_internal_compliance",
            parent: "report",
          },
        ],
      },
      {
        title: "Notices",
        icon: "/images/leftnav/report/show-cause-notice.svg",
        parentLink: "/report/show-cause-notice",
        link: "/report/show-cause-notice",
        name: "report_show_cause_notice",
        parent: "admin",
      },
      {
        title: "Certificate",
        icon: "/images/navigation-icons/certificate.svg",
        link: "/report/compliance-certificate",
        parentLink: "/report/compliance-certificate",
        name: "report_certificate",
        parent: "report",
      },
      {
        title: "Certificate Summary",
        icon: "/images/navigation-icons/certificate.svg",
        link: "/report/certificate-summary",
        parentLink: "/report/certificate-summary",
        name: "report_certificate_summary",
        parent: "report",
      },
      {
        title: "Logs",
        icon: "/images/leftnav/reports.svg",
        parentLink: "/reports",
        name: "report_logs",
        parent: "report",
        childrens: [
          {
            title: "Email Logs",
            link: "/report/logs/email-logs",
            name: "report_logs_email_logs",
            parent: "report",
          },
        ],
      },
    ],
  },
  {
    title: "Admin",
    icon: "/images/leftnav/admin.svg",
    parentLink: "/admin",
    name: "admin",
    parent: "admin",
    menu: [
      {
        title: "General",
        icon: "/images/leftnav/admin.svg",
        parentLink: "/admin/org-profile",
        name: "admin_general_org_profile",
        parent: "admin",
        childrens: [
          {
            title: "Org Profile",
            link: "/admin/org-profile",
            name: "admin_general_org_profile",
            parent: "admin",
          },
          {
            title: "Users",
            link: "/admin/users",
            name: "admin_general_user",
            parent: "admin",
          },
          {
            title: "Roles",
            link: "/admin/roles",
            name: "admin_general_role",
            parent: "admin",
          },
          {
            title: "Groups",
            link: "/admin/groups",
            name: "admin_general_group",
            parent: "admin",
          },

          {
            title: "Email Template",
            link: "/admin/email-template",
            name: "admin_general_email_template",
            parent: "admin",
          },
          {
            title: "User Guide",
            link: "/admin/user-guide",
            name: "admin_general_user_guide",
            parent: "admin",
          },
        ],
      },

      {
        title: "System",
        icon: "/images/leftnav/admin.svg",
        parentLink: "/admin",
        name: "admin_system_schedule",
        parent: "admin",
        childrens: [
          {
            title: "Schedules",
            link: "/admin/schedules",
            name: "admin_system_schedule",
            parent: "admin",
          },
        ],
      },
    ],
  },
  {
    title: "Support",
    icon: "/images/navigation-icons/support.svg",
    link: "/support",
    parentLink: "/support",
    name: "support",
    parent: "support",
    menu: [
      {
        title: "Support",
        icon: "/images/navigation-icons/support.svg",
        name: "support_support_open",
        parent: "support",
        childrens: [
          {
            title: "Open",
            link: "/support/open",
            name: "support_support_open",
            parent: "support",
          },
          {
            title: "In Progress",
            link: "/support/inprogress",
            name: "support_support_in_progress",
            parent: "support",
          },
          {
            title: "Closed",
            link: "/support/closed",
            name: "support_support_closed",
            parent: "support",
          },
        ],
      },
    ],
  },
];
